export default "__VITE_ASSET__BLgG6$Zj__"